import {
  computed,
  onMounted,
  onUnmounted,
  ref,
  useStore,
  watch,
} from '@nuxtjs/composition-api'
import { useKeycloakAuthModalParams } from '../config/auth/modal'

const calcFrameHeight = () => {
  const noticeEl = document.querySelector<HTMLDivElement>('.auth-modal-notice')
  return noticeEl ? `calc(100% - ${noticeEl.offsetHeight}px)` : '100%'
}

const getFrameDocument = () => {
  const iframe = document.querySelector<HTMLIFrameElement>('.auth-frame')
  return iframe?.contentDocument || iframe?.contentWindow.document
}

export type AuthFrameRedirectMessage = {
  type: string
  url?: string
  providerId: string
}

export const useKeycloakAuthElements = (params: ComputedRef<any>) => {
  const messageCallback = (e: MessageEvent<AuthFrameRedirectMessage>) => {
    if (e.data?.type === 'auth-redirect') {
      console.log('evt redirect url', e.data?.url)
      if (e.data.providerId) {
        const providersMap = {
          'provider-esiajcp': 'esiajcp',
          'provider-vtbid': 'vtbid',
        }
        const provider = providersMap[e.data?.providerId]
        const url = params.value?.src + `&providerId=${provider}`
        console.log('evt redirect provider providerId', e.data?.providerId)
        console.log('evt redirect provider provider', provider)
        console.log('evt redirect provider url', url)
        window.open(url, '_self')
      } else {
        window.open(e.data?.url, '_self')
      }
    }
  }

  onMounted(() => {
    window.addEventListener('message', messageCallback)
  })

  onUnmounted(() => {
    window.removeEventListener('message', messageCallback)
  })

  const hideBackButton = () => {
    const iframeDoc = getFrameDocument()
    const backButtonElement = iframeDoc?.querySelector('.back-button')
    backButtonElement?.style.visibility = 'hidden'
  }

  const augmentRedirectLink = (link) => {
    link.onmousedown = (e) => {
      e.preventDefault()
      window.postMessage({
        type: 'auth-redirect',
        providerId: e.currentTarget.id,
        url: e.currentTarget.href,
      })
    }
    link.onclick = (e) => {
      e.preventDefault()
    }
  }

  const augmentProviderLinks = () => {
    const iframeDoc = getFrameDocument()
    if (iframeDoc) {
      const providerIds = ['provider-esiajcp', 'provider-vtbid']
      const providerLinks = iframeDoc.querySelectorAll<HTMLAnchorElement>(
        providerIds.map((id) => `a#${id}`).join(', ')
      )

      providerLinks.forEach(augmentRedirectLink)
    }
  }
  return { hideBackButton, augmentProviderLinks }
}

export const useKeycloakAuthModal = (isVisible) => {
  const store = useStore()
  const allModalParams = useKeycloakAuthModalParams()
  const params = computed(
    () => allModalParams.value[store.getters['modal/GET_MODAL']]
  )
  const { hideBackButton, augmentProviderLinks } =
    useKeycloakAuthElements(params)

  const styles = ref<object | null>(null)

  let interval = null

  watch(
    () => isVisible.value,
    (value) => {
      if (value) {
        setTimeout(() => {
          styles.value = { height: calcFrameHeight() }
        }, 100)
        interval = setInterval(() => {
          hideBackButton()
          augmentProviderLinks()
        }, 200)
      } else {
        clearInterval(interval)
      }
    }
  )

  const onload = () => {
    styles.value = { height: calcFrameHeight() }
  }
  return { params, styles, onload }
}

export type BlitzButtonMessage = {
  event: string
  iframeId: string
  methodName: string
}

export const useBlitzAuthElements = (params: ComputedRef<any>) => {
  const validateMethod = (method: string) => {
    return (
      method &&
      (method.startsWith('externalIdps:esia') ||
        method.startsWith('externalIdps:vtb'))
    )
  }

  const authRedirectMessageCallback = (
    e: MessageEvent<AuthFrameRedirectMessage>
  ) => {
    if (e.data?.type === 'auth-redirect' && e.data?.url) {
      console.log('get message data', e.data)
      console.log('get message data type', e.data?.type)
      console.log('get message data url', e.data?.url)
      window.location.assign(e.data?.url)
    }
  }
  const blitzMessageCallback = (e: MessageEvent<BlitzButtonMessage>) => {
    if (e.data?.event === 'clickMethod' && validateMethod(e.data?.methodName)) {
      const providerId = e.data?.methodName.replace(
        'externalIdps',
        'used_externalIdps'
      )
      const url = params.value?.src + `&bip_action_hint=${providerId}`
      console.log('evt redirect provider methodName', e.data?.methodName)
      console.log('replaced redirect provider providerId', providerId)
      console.log('evt redirect provider url', url)
      window.open(url, '_self')
    }
  }

  onMounted(() => {
    window.addEventListener('message', blitzMessageCallback)
    window.addEventListener('message', authRedirectMessageCallback)
  })

  onUnmounted(() => {
    window.removeEventListener('message', blitzMessageCallback)
    window.removeEventListener('message', authRedirectMessageCallback)
  })
}
